import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface UpdateSubtypeVersionRequest {
  version_id: number;
  subtype_id?: number;
  valid_from?: string;
  valid_to?: string | null;
  descriptions?: Record<string, { language_code: string; translation_text: string }> | any;
}

export function updateSubtypeVersion(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'UpdateSubtypeVersion',
    description: 'Updates an existing subtype version',
    execute: (data: UpdateSubtypeVersionRequest): Observable<any> => {
      if (!data.version_id) {
        return of({ success: false, error: 'Missing required field: version_id' });
      }
      const payload: any = {};
      if (data.valid_from !== undefined) payload.valid_from = data.valid_from;
      if (data.valid_to !== undefined) payload.valid_to = data.valid_to === '' ? null : data.valid_to;
      if (data.descriptions !== undefined) payload.descriptions = data.descriptions;

      return componentDataSourceService.http.put<any>(
        `${environment.apiUrl}/events/subtypes/versions/${data.version_id}`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      ).pipe(
        tap(() => {
          dataSharingService.setData('subtypes_updated', {
            timestamp: Date.now(),
            ...(data.subtype_id && { subtype_id: data.subtype_id })
          });
        }),
        catchError(err => {
          console.error('[UpdateSubtypeVersion] Error:', err);
          throw err;
        })
      );
    }
  };
}
